import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLeagueMapping } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew";

export const useDeleteLeagueMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ leagueId, id }: { leagueId: number; id: number }) =>
      deleteLeagueMapping(leagueId, id),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [LeaguesNewQueryKeys.LeagueMappings, variables.leagueId],
      });
    },
  });
};
